// Copyright (c) Docugami, Inc. All rights reserved.

import { IExplorerNavigationGroup } from 'hooks/ExplorerNavigationGroups';
import styled from 'styled-components'
import { NavigationItemGroup } from "./NavigationItemGroup";

const NavigationListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const NavigationListGroupsContainer = styled(NavigationListContainer)`
    gap: 2px;
`;

interface ExplorerNavigationListProps {
    groups: IExplorerNavigationGroup[],
    selectedId?: string;
}

export const ExplorerNavigationList = (props: ExplorerNavigationListProps): JSX.Element => {
    return (
        <NavigationListContainer>
            <NavigationListGroupsContainer>
            {
                props.groups.map(group => {
                    return (
                        <NavigationItemGroup
                            key={group.id}
                            title={group.title}
                            icon={group.icon}
                            items={group.items}
                            group={group.id}
                            emptyPlaceholder={group.placeholder}
                            selectedId={props.selectedId}
                            collapsedItemCount={group.collapsedItemCount ?? 5}
                            onExpand={group.onExpand}
                            statusItems={group.statusItems} />
                    )
                })
            }
            </NavigationListGroupsContainer>
        </NavigationListContainer>
    );
}
